<template>
  <div class="user-learning-progress-view">
    <ImageBar title="我的学习进度" height="80px"/>
    <div class="progress-container">
      <UserLearningProgress />
    </div>
  </div>
</template>

<script>
import ImageBar from '@/components/ImageBar.vue'
import UserLearningProgress from '@/components/UserLearningProgress.vue'

export default {
  name: 'UserLearningProgressView',
  components: {
    ImageBar,
    UserLearningProgress
  },
  created() {
    if (!this.$root.isLoggedIn) {
      this.$goToLogin(this.$route.fullPath)
    }
  }
}
</script>

<style scoped>
.user-learning-progress-view {
  min-height: 100vh;
  background: #f5f7fa;
}

.progress-container {
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .progress-container {
    padding: 16px;
  }
}
</style>
